var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center",staticStyle:{"height":"100vh"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"200","width":"10"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }